"use client";

import { GoogleTagManager, GoogleAnalytics } from "@next/third-parties/google";

export default function GoogleIntegration({ gaId, gtmId }) {
  return (
    <>
      {gaId && <GoogleAnalytics gaId={gaId} />}
      {gtmId && <GoogleTagManager gtmId={gtmId} />}
    </>
  );
}
